import { render, staticRenderFns } from "./3d-split.vue?vue&type=template&id=7456cfc0&scoped=true&"
import script from "./3d-split.vue?vue&type=script&lang=js&"
export * from "./3d-split.vue?vue&type=script&lang=js&"
import style0 from "./3d-split.vue?vue&type=style&index=0&id=7456cfc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7456cfc0",
  null
  
)

export default component.exports